<template>
  <form ref="form">
    <div id="card-element">
      <!-- a Stripe Element will be inserted here. -->
    </div>
  </form>
</template>

<script>
  export default {
    name: 'add-card-form',
    data () {
      return {
        loading: false,
        card: null,
        mode: 'source',
        stripe: window.Stripe(this.$config.stripeApiKey),
        elements: null
      }
    },
    mounted () {
      this.elements = this.stripe.elements()
      this.card = this.elements.create('card', {hidePostalCode: true})
      this.card.mount('#card-element')
      this.clear()
    },
    methods: {
      clear () {
        this.loading = false
        this.card.clear()
      },
      accept () {
        if (this.mode === 'source') {
          return this.createSource()
        }
        return this.createToken()
      },
      createSource () {
        return new Promise((resolve, reject) => {
          this.loading = true
          this.stripe.createSource(this.card, {}).then((result) => {
            this.loading = false
            if (result.error) {
              reject(result.error)
            } else {
              resolve(result)
            }
          })
        })
      },
      createToken () {
        return new Promise((resolve, reject) => {
          this.loading = true
          this.stripe.createToken(this.card, {}).then((result) => {
            this.loading = false
            if (result.error) {
              reject(result.error)
            } else {
              resolve(result)
            }
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  form {
    width: 100%;
    height: 100%;
    padding: 25px;
    text-align: center;
  }

  form button {
    margin-top: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/stripe/CardForm.vue